import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { timer } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ToastService } from '@shared/ui/kit/toast/toast.service';

@UntilDestroy()
@Component({
  selector: 'loop-copy-value',
  templateUrl: './copy-value.component.html',
  styleUrls: ['./copy-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CopyValueComponent {
  private readonly clipboard: Clipboard = inject(Clipboard);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly toastService: ToastService = inject(ToastService);

  @Input() value?: string;
  @Input() notificationMessage: string = 'Value copied to clipboard';

  protected isValueCopied: boolean = false;

  copyValue(): void {
    this.clipboard.copy(this.value);
    this.isValueCopied = true;
    this.toastService.info({ title: this.notificationMessage });

    timer(5000)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.isValueCopied = false;
        this.changeDetectorRef.detectChanges();
      });
    this.changeDetectorRef.detectChanges();
  }
}
